import { render, staticRenderFns } from "./BeritaKegiatanTable.vue?vue&type=template&id=6b31952e&"
import script from "./BeritaKegiatanTable.vue?vue&type=script&lang=js&"
export * from "./BeritaKegiatanTable.vue?vue&type=script&lang=js&"
import style0 from "./BeritaKegiatanTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports